export default {
  methods: {
    formatErrors(errors) {
      return Object.values(errors).flat().join('<br/> ');
    },
  },
};
